'use strict';
define(['app'], function (app) {
    app.component('stTablePagination', {
        transclude: true,
        templateUrl: 'app/components/st-table-pagination/st-table-pagination.html',
        bindings: {
            page: '<',
            pages: '<',
            onPrevious: '&',
            onNext: '&'
        }
    });
});
